import React from 'react';

import Images from '../basics/Images';

export default () => (
  <img
    src={Images.Local.Spinner}
    style={{ width: '100px', margin: 'auto', display: 'block' }}
    alt="Loading..."
  />
);
